import config from "./config.json";

export enum HTTP_METHOD {
    GET = "get",
    POST = "post",
    PUT = "put",
    PATCH = "patch",
    DELETE = "delete"
}

export const ADMIN_APP = 'admin-app';

export const GA_MEASUREMENT_ID: string = config.GA_MEASUREMENT_ID;

export const REACT_APP_STS_AUTHORITY: string = config.REACT_APP_STS_AUTHORITY;
export const REACT_APP_CLIENT_ID: string = config.REACT_APP_CLIENT_ID;
export const REACT_APP_RESPONSE_TYPE: string = config.REACT_APP_RESPONSE_TYPE;
export const REACT_APP_CLIENT_SCOPE: string = config.REACT_APP_CLIENT_SCOPE;
export const REACT_APP_LOGIN_URL: string = config.REACT_APP_LOGIN_URL;
export const REACT_APP_IDENTITY_API_BASE_URL: string = config.REACT_APP_IDENTITY_API_BASE_URL;

export enum REDIRECT_ERROR_TYPE {
    unauthorized = "unauthorized"
}
